/** Client for the Traverse Worker API (same-origin, cookie sessions). */

export interface ApiUser {
  id: string
  email: string
  name: string
}

export interface RemoteTour {
  id: string
  name: string
  sport: string
  kind: string
  data: unknown | null
  updatedAt: number
  deleted: boolean
}

export class ApiError extends Error {
  constructor(
    public status: number,
    message: string,
  ) {
    super(message)
  }
}

async function request<T>(path: string, init?: RequestInit): Promise<T> {
  const res = await fetch(path, {
    credentials: 'same-origin',
    headers: init?.body ? { 'content-type': 'application/json' } : undefined,
    ...init,
  })
  const body = (await res.json().catch(() => ({}))) as { error?: string }
  if (!res.ok) throw new ApiError(res.status, body.error ?? `request failed (${res.status})`)
  return body as T
}

export const api = {
  me: () => request<{ user: ApiUser | null }>('/api/auth/me'),
  register: (email: string, name: string, password: string) =>
    request<{ user: ApiUser }>('/api/auth/register', { method: 'POST', body: JSON.stringify({ email, name, password }) }),
  login: (email: string, password: string) =>
    request<{ user: ApiUser }>('/api/auth/login', { method: 'POST', body: JSON.stringify({ email, password }) }),
  logout: () => request<{ ok: true }>('/api/auth/logout', { method: 'POST' }),
  pullTours: (since: number) => request<{ tours: RemoteTour[]; now: number }>(`/api/tours?since=${since}`),
  pushTours: (tours: unknown[]) =>
    request<{ accepted: string[]; rejected: { id: string; reason: string }[]; now: number }>('/api/tours', {
      method: 'PUT',
      body: JSON.stringify({ tours }),
    }),
}
